"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _NotificationsProvider = require("./NotificationsProvider");

var getStatusIcon = function getStatusIcon(status) {
  switch (status) {
    case _NotificationsProvider.NOTIFICATION_STATUS.DANGER:
      return 'fas fa-times-circle';

    case _NotificationsProvider.NOTIFICATION_STATUS.SUCCESS:
      return 'fas fa-check-circle';

    case _NotificationsProvider.NOTIFICATION_STATUS.WARNING:
      return 'fas fa-exclamation-circle';

    case _NotificationsProvider.NOTIFICATION_STATUS.LOADING:
      return 'fas fa-circle-notch fa-spin';

    case _NotificationsProvider.NOTIFICATION_STATUS.INFO:
      return 'fas fa-info-circle';

    default:
      return 'fas fa-info-circle';
  }
};

var Notification = function Notification(_ref) {
  var alias = _ref.alias,
      elementChar = _ref.elementChar,
      modifierChar = _ref.modifierChar,
      status = _ref.status,
      title = _ref.title,
      message = _ref.message,
      onClose = _ref.onClose;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: alias + " " + alias + modifierChar + status
  }, /*#__PURE__*/_react.default.createElement(_.IconButton, {
    size: "s",
    onClick: onClose,
    className: "" + alias + elementChar + "close",
    color: "black",
    icon: "fas fa-times"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "header"
  }, status && /*#__PURE__*/_react.default.createElement("div", {
    className: "" + alias + elementChar + "icon"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "" + getStatusIcon(status)
  })), title && /*#__PURE__*/_react.default.createElement("p", {
    className: "" + alias + elementChar + "title"
  }, title)), message && /*#__PURE__*/_react.default.createElement("p", {
    className: "" + alias + elementChar + "message"
  }, message));
};

Notification.propTypes = {
  alias: _propTypes.default.string,
  elementChar: _propTypes.default.string,
  modifierChar: _propTypes.default.string,
  status: _propTypes.default.string,
  title: _propTypes.default.node,
  message: _propTypes.default.node,
  onClose: _propTypes.default.func
};
Notification.defaultProps = {
  alias: 'Notification',
  elementChar: '_',
  modifierChar: '___'
};
var _default = Notification;
exports.default = _default;